import React from "react"

import { IGetJobsResponse, IGetPendingApplicationStudents, IGetResponseJobsDetails } from "api/reactQuery/queries/jobs.types"
import Dialog from "components/common/dialog/dialog"
import Application from "components/module/editJob/application"
import { useTranslation } from "react-i18next"

interface IHrApplicationDialog {
  open: boolean
  onClose: () => void
  onDeleteClick?: () => void
  onActionButtonClick: () => void
  actionAcceptText: string
  studentPendingApplication?: IGetPendingApplicationStudents
  job: IGetJobsResponse
}

const HrApplicationDialog: React.FC<IHrApplicationDialog> = ({
  open,
  onClose,
  onDeleteClick,
  onActionButtonClick,
  actionAcceptText,
  studentPendingApplication,
  job,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      titleText={t("jobs.jobApplication")}
      open={open}
      onClose={onClose}
      onDeleteClick={onDeleteClick}
      desktopMaxWidth="1040px"
      tabletMaxWidth="534px"
      actionAcceptText={actionAcceptText}
      onActionButtonClick={onActionButtonClick}
    >
      {studentPendingApplication && (
        <Application
          jobState={{
            ...job,
            responsibilities: "",
            qualifications: "",
          } as IGetResponseJobsDetails}
          studentId={studentPendingApplication}
        />
      )}
    </Dialog>
  )
}

export default HrApplicationDialog
